export function ArrowUp() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.51239 14.5795C9.55435 14.8186 9.7567 15 10 15C10.2737 15 10.4956 14.7705 10.4956 14.4873V6.88192L13.154 9.83856L13.2226 9.90234C13.4158 10.0512 13.6828 10.0299 13.8548 9.83856C14.0484 9.6233 14.0484 9.2743 13.8548 9.05904L10.4169 5.23538C10.3287 5.09377 10.1749 5 10 5C9.82505 5 9.67128 5.09377 9.58308 5.23538L6.14516 9.05904L6.08781 9.13538C5.954 9.3502 5.97312 9.64722 6.14516 9.83856L6.2138 9.90234C6.40695 10.0512 6.674 10.0299 6.84604 9.83856L9.5044 6.88324V14.4873L9.51239 14.5795Z"
        fill="#606B85"
      />
    </svg>
  );
}
